import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class AdminBrandCreateSocialMediaRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly url!: string;

  public constructor(id: Guid, url: string) {
    this.id = id;
    this.url = url;
  }
}
